import { wrapErrorHandler } from "../../utils/wrap_error_handler";
import http from "../../http";
import QuestionFormInterface from "./question_form_interface";
import { QuestionForm } from "../../../../domain/entities/search-form/question_form";

class QuestionFormRepository implements QuestionFormInterface {
  async responseQuestions(
    searchFormID: number,
    trainingID: number,
    questionID: number,
    questionForm: QuestionForm
  ): Promise<number> {
    return wrapErrorHandler<number>(async () => {
      const response = await http.post(
        `/api/decola/searchForms/${searchFormID}/training/${trainingID}/question/${questionID}/response`,
        questionForm
      );
      return response.data;
    });
  }

  async get(searchFormID: number,trainingID: number, page: number): Promise<QuestionForm> {
    return wrapErrorHandler<QuestionForm>(async () => {
      const response = await http.get(
        `/api/decola/searchForms/${searchFormID}/training/${trainingID}/page/${page}`
      );
      return response.data;
    });
  }
}

export default new QuestionFormRepository() as QuestionFormInterface;
